export const formatElo = (num: number): number => Math.round(num);
